/**
 * HorarioTurnosApiClient – /api/v1/businesses/{businessId}/horario-turnos (nexo-api 333, A).
 * Los turnos del negocio (temprano/tarde por dia) y quien los alterna por semana. Las tres rutas son de gerente.
 * El cuerpo lo arma application/horarios/turnos.js (cuerpoTurno, cuerpoAlternancia): aqui solo viaja.
 */

import { ApiBase } from './ApiBase.js';

const base = (businessId) => `/api/v1/businesses/${businessId}/horario-turnos`;

export const HorarioTurnosApiClient = {
  /** { turnos:[{turno,diaSemana,horaEntrada,...}], alternancias:[{colaboradorId,nombre,semanaAncla,turnoAncla,activo}] } */
  leer: (businessId) => ApiBase.get(base(businessId)),
  guardarTurno: (businessId, cuerpo) => ApiBase.put(`${base(businessId)}/turnos`, cuerpo),
  guardarAlternancia: (businessId, cuerpo) => ApiBase.put(`${base(businessId)}/alternancia`, cuerpo),
};
